import { useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import Hero from './components/Hero';
import TrustBadges from './components/TrustBadges';
import AboutSection from './components/AboutSection';
import CategoryCards from './components/CategoryCards';
import HowItWorks from './components/HowItWorks';
import FeaturedArticles from './components/FeaturedArticles';
import SafetySection from './components/SafetySection';
import CategoryButtons from './components/CategoryButtons';
import Testimonial from './components/Testimonial';
import CTASection from './components/CTASection';

const SITE_URL = 'https://vigorbuy.courses';
const LOGO_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg';

export default function Home() {
  const jsonLd = useMemo(() => ({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${SITE_URL}/#organization`,
        'name': 'VigorBuy.courses',
        'url': SITE_URL,
        'logo': LOGO_URL,
        'description': 'The largest product discovery hub helping shoppers find, compare, and discover products faster through the Vigorbuy Spreadsheet system.',
        'foundingDate': '2024',
        'sameAs': [
          'https://kaspreadsheet.com',
        ],
      },
      {
        '@type': 'WebSite',
        '@id': `${SITE_URL}/#website`,
        'url': SITE_URL,
        'name': 'Vigorbuy Spreadsheet - The Largest Product Discovery Hub',
        'description': 'Discover the best Vigorbuy Spreadsheet collections, trending products, trusted guides, and shopping tutorials in one place.',
        'inLanguage': 'en-US',
        'publisher': { '@id': `${SITE_URL}/#organization` },
      },
      {
        '@type': 'WebPage',
        '@id': `${SITE_URL}/#webpage`,
        'url': SITE_URL,
        'name': 'Vigorbuy Spreadsheet - Product Discovery Hub',
        'description': 'Discover trending products, trusted shopping guides, and category-based collections through the Vigorbuy Spreadsheet system.',
        'inLanguage': 'en-US',
        'isPartOf': { '@id': `${SITE_URL}/#website` },
        'about': { '@id': `${SITE_URL}/#organization` },
      },
    ],
  }), []);

  return (
    <>
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <Hero />
        <TrustBadges />
        <AboutSection />
        <CategoryCards />
        <HowItWorks />
        <FeaturedArticles />
        <SafetySection />
        <CategoryButtons />
        <Testimonial />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}